import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import { flattenData, secondsToHHMM } from "../../../Utilitie";

const NKJYardMWData = ({ data }) => {
  const key = [
    "CC",
    "PREMIUM",
    "Intensive",
    "Total Rakes",
    "Total Exam Time",
    "Avg. Exam Time",
    "MR Sick (inc B.Van)",
    "ROH",
    "POH (inc B.Van)",
    "NPOH",
    "Gap or Position Change",
    "Inter Mix",
    "BMBS (Knorr / Escorts / Conven.)",
    "Total",
    "Avg. Shunt Per rake",
    "Avg. Release to Departure",
    "Avg. Arrival to Departure",
  ];

  const years = [...new Set(data.map((o) => o.F_YEAR))];
  const monthOrder = [
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  const tableRef = useRef();
  const table1 = useRef();
  const table2 = useRef();
  const table3 = useRef();
  const table4 = useRef();
  const table5 = useRef();
  const tableRefArray = [table1, table2, table3, table4, table5];
  const sum = (year, column) => {
    return data
      .filter((o) => o.F_YEAR === year)
      .reduce((s, o) => s + Number(o[column] || 0), 0);
  };

  const avg = (year, column) => {
    const items = data.filter((o) => o.F_YEAR === year);
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };
  const avg1 = (year, column) => {
    const items = data.filter(
      (o) => o.F_YEAR === `${year.slice(0, 4) - 1}-${year.slice(2, 4)}`,
    );
    const total = items.reduce((s, o) => s + Number(o[column] || 0), 0);
    return items.length ? (total / items.length).toFixed(2) : 0;
  };

  return (
    <div>
      {" "}
      <h6 className="p-3 bg-dark text-white">
        NKJ YARD EXAMINATION FINANCIAL YEAR WISE SUMMARY
      </h6>
      <div className="table-responsive">
        {years.map((year, ind) => {
          return (
            <div>
              <table
                ref={tableRefArray[years.indexOf(year)]}
                className="table table-bordered table-striped text-center "
                style={{ fontSize: "13px" }}
              >
                <thead>
                  <tr className="table-dark text-center">
                    <th></th>
                    <>
                      <th colSpan={17}> NKJ YARD EXAMINATION ({year})</th>
                    </>
                  </tr>
                  <tr
                    className="table-dark text-center"
                    style={{ fontWeight: "bold" }}
                  >
                    <th></th>
                    <>
                      <th colSpan={6}>EXAMINATION TYPE </th>
                      <th colSpan={9}>SICK MARKING </th>
                      <th colSpan={2}>DETENTION </th>
                    </>
                  </tr>

                  <tr
                    className="table-dark text-center align-middle"
                    style={{ fontWeight: "bold" }}
                  >
                    <th>Month</th>

                    {key.map((Head, i) => (
                      <th
                        key={i}
                        style={{
                          whiteSpace: "normal",
                        }}
                      >
                        {Head}
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody key={ind}>
                  {monthOrder.map((month, i) => {
                    let tempMonths = [
                      ...new Set(
                        data
                          .filter((x) => x.F_YEAR === year)
                          .map((x) => x.MONTH),
                      ),
                    ];

                    if (!tempMonths.includes(month)) return null;

                    const row = data.find(
                      (o) => o.F_YEAR === year && o.MONTH === month,
                    );

                    return (
                      <tr key={i}>
                        <td>{month}</td>
                        <td>{row?.EX_TY_CC || 0}</td>
                        <td>{row?.EX_TY_PREMIUM || 0}</td>
                        <td>{row?.EX_TY_INTENSIVE || 0}</td>
                        <td>{row?.TOTAL_RAKES || 0}</td>
                        <td>{secondsToHHMM(row?.TOTAL_EXAM_TIME || 0)}</td>
                        <td>{secondsToHHMM(row?.AVG_EXAM_TIME || 0)}</td>
                        <td>{row?.SM_MR_Sick_inc_B_Van || 0}</td>
                        <td>{row?.SM_ROH || 0}</td>
                        <td>{row?.SM_POH_inc_B_Van || 0}</td>
                        <td>{row?.SM_NPOH || 0}</td>
                        <td>{row?.SM_Gap_or_Position_Change || 0}</td>
                        <td>{row?.SICK_MR_SER_INTER_MIX || 0}</td>
                        <td>{row?.SICK_MR_SER_BMBS || 0}</td>
                        <td>
                          {row?.["SM_MR_Sick_inc_B_Van"] +
                            row?.["SM_ROH"] +
                            row?.["SM_POH_inc_B_Van"] +
                            row?.["SM_NPOH"] +
                            row?.["SM_Gap_or_Position_Change"] +
                            row?.["SICK_MR_SER_INTER_MIX"] +
                            row?.["SICK_MR_SER_BMBS"] || 0}
                        </td>
                        <td>{row?.SICK_MR_SER_Avg_Shunt_per_Rake || 0}</td>
                        <td>
                          {secondsToHHMM(
                            row?.["Det_Avg_Release_to_Departure"] || 0,
                          )}
                        </td>
                        <td>
                          {secondsToHHMM(
                            row?.["Det_Avg_Arrival_to_Departure"] || 0,
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr className="table-dark fw-bold">
                    <td>Total</td>

                    <td>{sum(year, "EX_TY_CC")}</td>
                    <td>{sum(year, "EX_TY_PREMIUM")}</td>
                    <td>{sum(year, "EX_TY_INTENSIVE")}</td>
                    <td>{sum(year, "TOTAL_RAKES")}</td>
                    <td>{secondsToHHMM(sum(year, "TOTAL_EXAM_TIME"))}</td>
                    <td>{secondsToHHMM(sum(year, "AVG_EXAM_TIME"))}</td>

                    <td>{sum(year, "SM_MR_Sick_inc_B_Van")}</td>
                    <td>{sum(year, "SM_ROH")}</td>
                    <td>{sum(year, "SM_POH_inc_B_Van")}</td>
                    <td>{sum(year, "SM_NPOH")}</td>
                    <td>{sum(year, "SM_Gap_or_Position_Change")}</td>
                    <td>{sum(year, "SICK_MR_SER_INTER_MIX")}</td>
                    <td>{sum(year, "SICK_MR_SER_BMBS")}</td>

                    <td>
                      {[
                        "SM_MR_Sick_inc_B_Van",
                        "SM_ROH",
                        "SM_POH_inc_B_Van",
                        "SM_NPOH",
                        "SM_Gap_or_Position_Change",
                        "SICK_MR_SER_INTER_MIX",
                        "SICK_MR_SER_BMBS",
                      ].reduce((s, c) => s + sum(year, c), 0)}
                    </td>

                    <td>{sum(year, "SICK_MR_SER_Avg_Shunt_per_Rake")}</td>
                    <td>
                      {secondsToHHMM(sum(year, "Det_Avg_Release_to_Departure"))}
                    </td>
                    <td>
                      {secondsToHHMM(sum(year, "Det_Avg_Arrival_to_Departure"))}
                    </td>
                  </tr>

                  <tr className="table-dark fw-bold">
                    <td>Average</td>

                    <td>{avg(year, "EX_TY_CC")} </td>
                    <td>{avg(year, "EX_TY_PREMIUM")}</td>
                    <td>{avg(year, "EX_TY_INTENSIVE")}</td>
                    <td>{avg(year, "TOTAL_RAKES")}</td>
                    <td>{secondsToHHMM(avg(year, "TOTAL_EXAM_TIME"))}</td>
                    <td>{secondsToHHMM(avg(year, "AVG_EXAM_TIME"))}</td>

                    <td>{avg(year, "SM_MR_Sick_inc_B_Van")}</td>
                    <td>{avg(year, "SM_ROH")}</td>
                    <td>{avg(year, "SM_POH_inc_B_Van")}</td>
                    <td>{avg(year, "SM_NPOH")}</td>
                    <td>{avg(year, "SM_Gap_or_Position_Change")}</td>
                    <td>{avg(year, "SICK_MR_SER_INTER_MIX")}</td>
                    <td>{avg(year, "SICK_MR_SER_BMBS")}</td>

                    <td>
                      {(
                        [
                          "SM_MR_Sick_inc_B_Van",
                          "SM_ROH",
                          "SM_POH_inc_B_Van",
                          "SM_NPOH",
                          "SM_Gap_or_Position_Change",
                          "SICK_MR_SER_INTER_MIX",
                          "SICK_MR_SER_BMBS",
                        ].reduce((s, c) => s + Number(avg(year, c)), 0) / 7
                      ).toFixed(2)}
                    </td>

                    <td>{avg(year, "SICK_MR_SER_Avg_Shunt_per_Rake")}</td>
                    <td>
                      {secondsToHHMM(avg(year, "Det_Avg_Release_to_Departure"))}
                    </td>
                    <td>
                      {secondsToHHMM(avg(year, "Det_Avg_Arrival_to_Departure"))}
                    </td>
                  </tr>
                  <tr className="table-dark fw-bold">
                    <td>Var %</td>

                    <td>
                      {(
                        ((avg(year, "EX_TY_CC") - avg1(year, "EX_TY_CC")) /
                          avg1(year, "EX_TY_CC")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {(
                        ((avg(year, "EX_TY_PREMIUM") -
                          avg1(year, "EX_TY_PREMIUM")) /
                          avg1(year, "EX_TY_PREMIUM")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "EX_TY_INTENSIVE") -
                          avg1(year, "EX_TY_INTENSIVE")) /
                          avg1(year, "EX_TY_INTENSIVE")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "TOTAL_RAKES") -
                          avg1(year, "TOTAL_RAKES")) /
                          avg1(year, "TOTAL_RAKES")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "TOTAL_EXAM_TIME") -
                          avg1(year, "TOTAL_EXAM_TIME")) /
                          avg1(year, "TOTAL_EXAM_TIME")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %{" "}
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "AVG_EXAM_TIME") -
                          avg1(year, "AVG_EXAM_TIME")) /
                          avg1(year, "AVG_EXAM_TIME")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>

                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_MR_Sick_inc_B_Van") -
                          avg1(year, "SM_MR_Sick_inc_B_Van")) /
                          avg1(year, "SM_MR_Sick_inc_B_Van")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_ROH") - avg1(year, "SM_ROH")) /
                          avg1(year, "SM_ROH")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_POH_inc_B_Van") -
                          avg1(year, "SM_POH_inc_B_Van")) /
                          avg1(year, "SM_POH_inc_B_Van")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_NPOH") - avg1(year, "SM_NPOH")) /
                          avg1(year, "SM_NPOH")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SM_Gap_or_Position_Change") -
                          avg1(year, "SM_Gap_or_Position_Change")) /
                          avg1(year, "SM_Gap_or_Position_Change")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SICK_MR_SER_INTER_MIX") -
                          avg1(year, "SICK_MR_SER_INTER_MIX")) /
                          avg1(year, "SICK_MR_SER_INTER_MIX")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {" "}
                      {(
                        ((avg(year, "SICK_MR_SER_BMBS") -
                          avg1(year, "SICK_MR_SER_BMBS")) /
                          avg1(year, "SICK_MR_SER_BMBS")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>

                    <td>
                      -
                      {/* {(
                        [
                          "SM_MR_Sick_inc_B_Van",
                          "SM_ROH",
                          "SM_POH_inc_B_Van",
                          "SM_NPOH",
                          "SM_Gap_or_Position_Change",
                          "SICK_MR_SER_INTER_MIX",
                          "SICK_MR_SER_BMBS",
                        ].reduce((s, c) => s + Number(avg(year, c)), 0) / 7
                      ).toFixed(2)} */}
                    </td>

                    <td>
                      {" "}
                      {(
                        ((avg(year, "SICK_MR_SER_Avg_Shunt_per_Rake") -
                          avg1(year, "SICK_MR_SER_Avg_Shunt_per_Rake")) /
                          avg1(year, "SICK_MR_SER_Avg_Shunt_per_Rake")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {(
                        ((avg(year, "Det_Avg_Release_to_Departure") -
                          avg1(year, "Det_Avg_Release_to_Departure")) /
                          avg1(year, "Det_Avg_Release_to_Departure")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                    <td>
                      {(
                        ((avg(year, "Det_Avg_Arrival_to_Departure") -
                          avg1(year, "Det_Avg_Arrival_to_Departure")) /
                          avg1(year, "Det_Avg_Arrival_to_Departure")) *
                        100
                      )
                        .toFixed(2)
                        .replace("Infinity", "0")}
                      %
                    </td>
                  </tr>
                </tfoot>
              </table>{" "}
              <div className="mb-3">
                <DownloadExcel
                  tableRef={tableRefArray[years.indexOf(year)]}
                  fileName={`Financial Year Summary NKJ Yard Ex  - ${year}`}
                />
              </div>
            </div>
          );
        })}{" "}
      </div>{" "}
    </div>
  );
};

export default NKJYardMWData;
